// extracted by css-extract-rspack-plugin
export default {"root":"sIWe1","label":"vip9O"};